document.addEventListener("DOMContentLoaded", function () {
  const productSection = document.querySelector(".product-section");

  if (!productSection) return;

  function updatePrices(target) {
    const priceElement =
      target.nextElementSibling.querySelector("span.price-label");
    const regularPrice = target
      .closest(".product-section")
      .querySelector("[data-product-custom-price]");
    const buttonPrice = target
      .closest(".product-section")
      .querySelector(".btn--add-to-cart [data-button-price]");

    if (priceElement) {
      const price = priceElement.innerText;
      regularPrice.innerText = price;
      buttonPrice.innerText = price;
    }
  }

  function handleSubscription(event) {
    const target = event.target;
    if (
      target.classList.contains("subscription-select") ||
      target.classList.contains("one-time-only")
    ) {
      updatePrices(target);
    }
  }

  productSection.addEventListener("change", handleSubscription);
});
